import Vue from 'vue';
import moment from 'moment';
import i18n from './i18n';

/** Global filters for Vue. Mostly localization date formats */

Vue.filter('dateTime', (date: Date | string) => {
  if (!date) { return ''; }
  return moment(date).format('L HH:mm');
});

Vue.filter('dateTimeOrNA', (date: Date | string) => {
  if (!date) { 
    return i18n.t('general.time_na');
  }
  return moment(date).format('L HH:mm');
});

Vue.filter('date', (date: Date | string) => {
  if (!date) { return ''; }
  return moment(date).format('L');
});

Vue.filter('time', (date: Date | string) => {
  if (!date) {
    return i18n.t('general.time_na');
  }
  return moment(date).format('HH:mm');
});

Vue.filter('emptyField', (content: string) => {
  if (!content) {
    return i18n.t('general.empty_field');
  }
  return content;
});

Vue.filter('quotaAmount', (quota: number, quotaType: number, currencySymbol: string, isMileageInstance: boolean) => {
  
  switch(quotaType) {
    case 1:
      if (isMileageInstance) {
        return (quota / 1609.34).toFixed(1) +   ' mi';
      }     
      return (quota / 1000).toFixed(1) + ' km';
    case 2:
      return quota / 100 + '  ' + currencySymbol;
    default:
      return quota + ' ' + i18n.t('general.pcs').toString();
  }
});
